/*
export const environment = {
  production: false,
  URL_ENV_TARGET: 'dev%2F',
  URL_BASE: 'https://gorentdev.sudtechnologies.com',
  URL_IMAGE: 'https://firebasestorage.googleapis.com/v0/b/gorent-e709f.appspot.com/o/dev%2F',
  URL_IMAGE_BASE: 'https://firebasestorage.googleapis.com/v0/b/gorent-e709f.appspot.com/o/',
  URL_IMAGE_SUFFIX: '?alt=media',
  REST_VERSION: '/api/v1',
  env: 'dev',
  
  ANGULAR_CLIENT_ID: 'angular_client',
  ANGULAR_CLIENT_SECRET: '123456',


  apiKey: "AIzaSyDlTviz6ghhaPqukfXWGpamJmNe52bOPng",
  authDomain: "gorent-e709f.firebaseapp.com",
  databaseURL: "https://gorent-e709f.firebaseio.com",
  projectId: "gorent-e709f",
  storageBucket: "gorent-e709f.appspot.com",
  messagingSenderId: "311782003197",
  appId: "1:311782003197:web:f4b0b3deff7652da",

  bankDefaultImage: 'https://firebasestorage.googleapis.com/v0/b/gorent-e709f.appspot.com/o/'+"static%2Fic_default.png?alt=media"
};*/

export const environment = {
  production: true,
  URL_ENV_TARGET: 'prod%2F',
  URL_BASE: 'https://gorentapi.sudtechnologies.com',
  URL_IMAGE: 'https://firebasestorage.googleapis.com/v0/b/gorent-e709f.appspot.com/o/prod%2F',
  URL_IMAGE_BASE: 'https://firebasestorage.googleapis.com/v0/b/gorent-e709f.appspot.com/o/',
  URL_IMAGE_SUFFIX: '?alt=media',
  REST_VERSION: '/api/v1',
  env: 'prod',
  
  ANGULAR_CLIENT_ID: 'angular_client',
  ANGULAR_CLIENT_SECRET: '123456',


  apiKey: "AIzaSyDlTviz6ghhaPqukfXWGpamJmNe52bOPng",
  authDomain: "gorent-e709f.firebaseapp.com",
  databaseURL: "https://gorent-e709f.firebaseio.com",
  projectId: "gorent-e709f",
  storageBucket: "gorent-e709f.appspot.com",
  messagingSenderId: "311782003197",
  appId: "1:311782003197:web:f4b0b3deff7652da",

  bankDefaultImage: 'https://firebasestorage.googleapis.com/v0/b/gorent-e709f.appspot.com/o/'+"static%2Fic_default.png?alt=media"
};



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/environments/environment.ts